module.exports = __webpack_public_path__ + "img/feature_buy_zh.4fce2365.png";